import React from "react"
import { useTranslation } from "react-i18next"
import Quote from "../common/Quote"

const MissionAndVision = () => {
  const { t } = useTranslation()

  return (
    <section className="mx-auto max-w-7xl p-8 space-y-4 bg-blue-100">
      <h2 className="text-xl md:text-2xl font-semibold">
        {t("about.mission-and-vision.title")}
      </h2>
      <div className="py-5">
        <Quote text={t("about.mission-and-vision.quote")} author="" />
        <Quote
          text={t("about.mission-and-vision.paragraph")}
          author={t("about.mission-and-vision.quote-author")}
        />
      </div>
    </section>
  )
}

export default MissionAndVision
